/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalPythonGraderContract = {
  Sample: "sample",
  Batch: "batch",
  ModelBacked: "model_backed",
} as const;
export type EvalPythonGraderContract = ClosedEnum<
  typeof EvalPythonGraderContract
>;

/** @internal */
export const EvalPythonGraderContract$inboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderContract
> = z.nativeEnum(EvalPythonGraderContract);
/** @internal */
export const EvalPythonGraderContract$outboundSchema: z.ZodNativeEnum<
  typeof EvalPythonGraderContract
> = EvalPythonGraderContract$inboundSchema;
